var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerseLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 350 350",
    enableBackground: "new 0 0 350 350",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 175,
    cy: 175,
    r: 175
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#241F20",
    points: "231.7,214 174,156.4 174,156.4 116.2,98.5 58.6,156.4 116.2,214 116.2,214 174,271.6  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E94F6",
    d: "M277.4,110.5L277.4,110.5c-15.9-15.9-41.8-15.9-57.6,0l0,0c-15.9,15.9-15.9,41.8,0,57.6l0,0 c5.5,5.5,12.3,9.1,19.3,10.9v27.7l38.4-38.5l0,0l0,0C293.4,152.3,293.4,126.4,277.4,110.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerseLogo);
export default __webpack_public_path__ + "static/media/verse-logo.281af299cdb367c3750d13ef358ffa21.svg";
export { ForwardRef as ReactComponent };